import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AlertMessage from '../../AlertMessage';


function Driver(props) {
  const [showDriverForm, setShowDriverForm] = useState(true);
  const [driverName, setDriverName] = useState('');
  const [driverPhone, setDriverPhone] = useState('');
  const { finYear } = props;
const [editingBusNoKey, setEditingBusNoKey] = useState(null); // Track the key (serial number)
  const [busno, setBusno] = useState('');
  const [root, setRoot] = useState('');
  const [address, setAddress] = useState('');
  const [roots, setRoots] = useState(['']);
  const [showForm, setShowForm] = useState(false);
  const udiseNumber = localStorage.getItem('udiseNumber'); // Get the udiseNumber from localStorage
  const [newBusNo, setNewBusNo] = useState('');
  const [busNumbers, setBusNumbers] = useState([]); // State to hold bus numbers
//  const [editingBusNo, setEditingBusNo] = useState(null);
 const [drivers, setDrivers] = useState([]); // State to hold the list of drivers
 const [rootData, setRootData] = useState({});
 const [isEditing, setIsEditing] = useState(false);
 const [editDriverName, setEditDriverName] = useState(null); // Track the driver being edited
// const[driverId, setDriverId]= useState('');
const language = localStorage.getItem("language");
  const driversUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers.json`;
  const handlePlusClick = (e) => {
    e.preventDefault();
    setShowForm(!showForm);
  };

  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  useEffect(() => {
      if (alertMessage) {
        setShowAlert(true);
        const timeoutId = setTimeout(() => {
          setShowAlert(false);
          setAlertMessage(""); 
        }, 3000);
        return () => clearTimeout(timeoutId);
      }
    }, [alertMessage]);


    const fetchDataroot1 = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${finYear}.json`);
        const fetchedData = response.data;
  
        setRootData(fetchedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
  
  useEffect(() => {
    fetchDataroot1();
  }, [udiseNumber]);

  const submitDriverForm = async (e) => {
    e.preventDefault();

    if (!driverName || !driverPhone || !roots.length || !busno) {
      setAlertMessage('Please fill out all fields before submitting.');
      return;
    }

    const driverData = {
      driverName,
      driverPhone,
      address,
      roots, // Save the array of roots
      busno,
    };

    try {
      if (isEditing) {
        await axios.delete(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers/${editDriverName}.json`);
        await axios.put(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers/${driverName}.json`, driverData);
        setAlertMessage('Driver information updated successfully!');
      } else {
        await axios.put(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers/${driverName}.json`, driverData);
        setAlertMessage('Driver information saved successfully!');
      }

      setDriverName('');
      setDriverPhone('');
      setRoots(['']); // Reset roots to have one empty root
      setBusno('');
      setIsEditing(false);

      const driversResponse = await axios.get(driversUrl);
      setDrivers(driversResponse.data ? Object.values(driversResponse.data) : []);
    } catch (error) {
      console.error('Error saving driver information:', error);
      setAlertMessage('Failed to save driver information.');
    }
  };

  const handleAddRoot = () => {
    setRoots([...roots, '']); // Add an empty string for a new root
  };

  const handleRootChange = (index, value) => {
    const updatedRoots = [...roots];
    updatedRoots[index] = value; // Update the specific root
    setRoots(updatedRoots);
  };

  const handleRemoveRoot = (index) => {
    const updatedRoots = roots.filter((_, i) => i !== index); // Remove the root at the specified index
    setRoots(updatedRoots);
  };


  const handleInputChange = (e) => {
    setNewBusNo(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
  
    if (!newBusNo) {
      setAlertMessage('Bus number is required!');
      return; // Exit if bus number is not provided
    }
    // Check if the bus number already exists in the busNumbers state
    if (busNumbers.includes(newBusNo)) {
      setAlertMessage('This bus number already exists!');
      return; // Prevent form submission if the bus number already exists
    }
    // Base URL for your Firebase database
    const driversUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers.json`;
  
    try {
      // If editing an existing bus number
      if (editingBusNoKey !== null) {
        // Construct the URL for the specific bus number you want to update
        const updateUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers/${editingBusNoKey}.json`;
        const dataToSave = { busNo: newBusNo }; // Prepare the new bus number data
  
        // Send a PATCH request to update the existing bus number
        const updateResponse = await fetch(updateUrl, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataToSave),
        });
  
        if (updateResponse.ok) {
          // Update local state to reflect the change
          setBusNumbers((prevBusNumbers) =>
            prevBusNumbers.map((num, index) =>
              index === editingBusNoKey ? newBusNo : num
            )
          );
          setAlertMessage('Bus No updated successfully!');
          // setEditingBusNo(null);
          setEditingBusNoKey(null);
        } else {
          console.error('Failed to update bus number:', updateResponse.statusText);
        }
      } else {
        // Fetch existing drivers to determine the next serial number
        const existingDriversResponse = await fetch(driversUrl);
        const existingDrivers = await existingDriversResponse.json();
        
        // Get existing keys and determine the next available key
        const existingSerialNos = Object.keys(existingDrivers || {}).filter(key => !isNaN(key)).map(Number);
        const highestSerialNo = Math.max(-1, ...existingSerialNos); // Start from -1 to avoid default 0
        const newSerialNo = highestSerialNo + 1;
  
        const saveUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers/${newSerialNo}.json`;
        const dataToSave = { busNo: newBusNo };
  
        const saveResponse = await fetch(saveUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(dataToSave),
        });
  
        if (saveResponse.ok) {
          setBusNumbers((prevBusNumbers) => [
            ...prevBusNumbers,
            newBusNo
          ]);
          setAlertMessage('Bus No saved successfully!');
        } else {
          console.error('Failed to save bus number:', saveResponse.statusText);
        }
      }
    } catch (error) {
      console.error('Error saving bus number:', error);
    }
  
    setNewBusNo(''); // Reset form fields
  };
  
  // Edit function to set the bus number and key to edit
  const handleEditBusNo = (busNumber, key, e) => {
    e.preventDefault();
    // setEditingBusNo(busNumber); // Set the bus number being edited
    setEditingBusNoKey(key); // Set the correct key for the bus number
    setNewBusNo(busNumber); // Pre-fill the input with the bus number
  };
  
  
 
  
  
  
  
useEffect(() => {
  const fetchBusNumbers = async () => {
    try {
      const response = await fetch(driversUrl);
      const data = await response.json();

      if (data) {
        // Extract bus numbers and filter out invalid or empty bus numbers
        const fetchedBusNumbers = Object.values(data)
          .map((bus) => bus.busNo)
          .filter((busNo) => busNo && busNo.trim() !== ""); // Ensure busNo is valid and non-empty
          
        setBusNumbers(fetchedBusNumbers);
      } else {
        setBusNumbers([]); // In case data is empty, set an empty array
      }
    } catch (error) {
      console.error('Error fetching bus numbers:', error);
    }
  };

  fetchBusNumbers();
}, [driversUrl]); // Runs when driversUrl changes



const handleDelete = async (busNumber) => {
  // Check if the bus number exists in local state
  if (!busNumbers.includes(busNumber)) {
      setAlertMessage('Bus number not found.');
      return;
  }

  // Construct the URL to fetch all drivers to find the correct key for deletion
  const driversUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers.json`; 

  try {
      const response = await fetch(driversUrl);
      const existingDrivers = await response.json();
      
      // Find the key corresponding to the bus number
      const driverKey = Object.keys(existingDrivers || {}).find(key => existingDrivers[key].busNo === busNumber);

      if (!driverKey) {
          setAlertMessage('Bus number not found in the database.');
          return;
      }

      // Construct the delete URL using the found key
      const deleteUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers/${driverKey}.json`; 

      // Perform the deletion
      const deleteResponse = await fetch(deleteUrl, {
          method: 'DELETE',
      });

      if (deleteResponse.ok) {
          // Remove from local state if deletion was successful
          setBusNumbers((prevBusNumbers) => 
              prevBusNumbers.filter((b) => b !== busNumber)
          );
          setAlertMessage('Bus number deleted successfully!');
      } else {
          console.error('Failed to delete bus number:', deleteResponse.statusText);
          setAlertMessage('Failed to delete bus number.');
      }
  } catch (error) {
      console.error('Error deleting bus number:', error);
      setAlertMessage('Failed to delete bus number.');
  }
};



useEffect(() => {
  const fetchDrivers = async () => {
    try {
      const driversResponse = await axios.get(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers.json`);
      const driversData = driversResponse.data;

      if (driversData) {
        const driverList = Object.values(driversData);
        setDrivers(driverList);
      } else {
        setDrivers([]);
      }
    } catch (error) {
      console.error('Error fetching driver data:', error);
    }
  };

  fetchDrivers();
}, [udiseNumber]);

const handleEdit3 = async (e, driver) => {
  e.preventDefault(); // Prevent default event behavior

  // Set the new values for editing
  setIsEditing(true); // Set editing mode to true
  setEditDriverName(driver.driverName); // Store the name of the driver to track the one being edited
  setDriverName(driver.driverName);
  setDriverPhone(driver.driverPhone);
  setAddress(driver.address);
 setRoots(driver.roots || []); // Set the roots for the driver being edited
  setBusno(driver.busno);
  // setDriverId(driver.id); // Assuming you have an id to identify the driver

  // No need to delete anything at this stage
};


// Function to handle saving the edited driver


const handleDelete1 = async (driver) => {
  try {
    await axios.delete(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/drivers/${driver.driverName}.json`);
    setAlertMessage('Driver deleted successfully!');

    const response = await axios.get(driversUrl);
    setDrivers(response.data ? Object.values(response.data) : []);
  } catch (error) {
    console.error('Error deleting driver:', error);
    setAlertMessage('Failed to delete driver.');
  }
};
  return (
    <div>
    <AlertMessage message={alertMessage} show={showAlert}/>

      {showDriverForm && (
        <div style={driverModalStyle}>
        <h3 className='text-center my-3' style={{ color: '#1B4332', fontWeight: '600' }}>
        {language === "English" ? "Driver Information  " : "चालक माहिती"}
        </h3>

        
          <form>

                      <div style={formRowStyle}>
                            <label htmlFor="driverName" style={labelStyle}>
                                {language === "English" ? "Driver Name" : "चालकाचे नाव"}
                            </label>
                            <input
                                type="text"
                                id="driverName"
                                value={driverName}
                                onChange={(e) => setDriverName(e.target.value)}
                                style={{ ...inputStyle, marginLeft: '-10px' }}

                                required
                            />
                          <label htmlFor="driverPhone" style={labelStyle}>
    {language === "English" ? "Phone No." : " फोन क्र."}
</label>
<input
    type="tel" // Use "tel" instead of "number"
    id="driverPhone"
    value={driverPhone}
    onChange={(e) => {
        const value = e.target.value;

        // Allow only digits and limit to 10 characters
        if (/^\d{0,10}$/.test(value)) {
            setDriverPhone(value);
        }
    }}
    maxLength={10} // Limit to 10 digits
    style={{ ...inputStyle, marginLeft: '-10px' }}
/>

                            <label  htmlFor="address" style={labelStyle}>{language==="English"? "Address" : "पत्ता" } </label>
                            <input
                                type="text" 
                                id="address"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                style={{ ...inputStyle, marginLeft: '-10px' }}
                            />
                        </div>
                        <div style={formRowStyle}>
                        <label htmlFor="root" style={labelStyle}>
                {language === "English" ? "Roots" : "मार्ग"}
              </label>
              {roots.map((root, index) => (  
                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                  <select
                    value={root}
                    onChange={(e) => handleRootChange(index, e.target.value)}
                    style={{ ...selectStyle, marginLeft: '10px' }}
                  >
                    <option value="">Select Root</option>
                    {Object.keys(rootData).map((key) => (
                      <option key={key} value={key}>
                        {`${rootData[key].fromtheway} - ${rootData[key].thewayup}`}
                      </option>
                    ))}
                  </select>
                  <button type="button" onClick={() => handleRemoveRoot(index)} style={deleteButtonStyle}>
                    <DeleteIcon />
                  </button>
                </div>
              ))}
              <button type="button" onClick={handleAddRoot} style={buttonStyle1}>
                Add Root
              </button>
                            <div>    
      <label htmlFor="busno"  style={labelStyle}>{language === "English" ? "Bus No " : "बस क्रमांक"}</label>
      
        <select
        
          id="busno"
          style={{...selectStyle, marginLeft:'65px'}}
          value={busno}
          onChange={(e) => setBusno(e.target.value)}
        >
          <option value="">Select Bus No</option>
          {busNumbers.map((busNumber, index) => (
            <option key={index} value={busNumber}>{busNumber}</option>
          ))}
        </select>
        <button onClick={handlePlusClick} style={{ 
              fontSize: '18px',
              marginLeft: '30px',
              backgroundColor: '#0dcaf0',
              borderRadius: '10px',
              padding: '5px',
              height: '36px',
           }}>➕</button>
      </div>
      </div>

      <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
  <button onClick={submitDriverForm} style={{ ...buttonStyle1, marginTop: '10px', fontSize: '16px', fontWeight: 'bold' }}>
    {isEditing ? 'Update' : 'Submit'}
  </button>
</div>



    <div style={boxStyle}>
    <div style={tableContainerStyle}>
  <table style={tableStyle1}>
    <thead>
      <tr>
        <th  style={thStyle}>{language === "English" ? "Driver Name  " : "चालकाचे नाव"}</th>
        <th style={thStyle}>{language === "English" ? "Driver Phone  " : "चालकाचा फोन क्रमांक"}</th>
        <th style={thStyle}>{language === "English" ? "Address  " : "चालकाचा पत्ता"}</th>
        <th  style={thStyle}>{language === "English" ? "Root " : "मार्ग"}</th>
        <th style={thStyle}>{language === "English" ? "Bus No  " : "बस क्रमांक"}</th>
        <th  style={thStyle}>{language === "English" ? "Action " : "कृती"}</th>
      </tr>
    </thead>
    <tbody>
  {drivers.length > 0 ? (
    drivers
      .filter(driver => driver && driver.driverName) // Ensure driver is not null and has a name
      .map((driver, index) => (
        <tr key={index}>
          <td style={tdStyle}>{driver.driverName || ''}</td>
          <td style={tdStyle}>{driver.driverPhone || ''}</td>
          <td style={tdStyle}>{driver.address || ''}</td>
          {/* <td style={tdStyle}>
            {rootData[driver.root] && `${rootData[driver.root].fromtheway} - ${rootData[driver.root].thewayup}`}
          </td> */}
          <td style={tdStyle}>
                      {driver.roots && driver.roots.map((root) => (
                        <div key={root}>
                          {rootData[root] ? `${rootData[root].fromtheway} - ${rootData[root].thewayup}` : root}
                        </div>
                      ))}
                    </td>
          <td style={tdStyle}>{driver.busno || ''}</td>
          <td style={tdStyle}>
            
            <button onClick={(e) => handleEdit3(e, driver)} style={editButtonStyle}> <EditIcon /></button>
            <button onClick={() => handleDelete1(driver)} style={deleteButtonStyle}> <DeleteIcon /></button>
          </td>
        </tr>
      ))
  ) : (
    <tr>
      <td colSpan="6" style={{ textAlign: 'center' }}>No drivers available</td>
    </tr>
  )}
</tbody>

  </table>
</div>



    </div>

    {showForm && (
      
      <div style={driverModalStyle}>
  <div style={{ 
      position: 'absolute', // Makes the form overlay
      top: '50%',  // Adjusts the form position vertically
      left: '50%', // Adjusts the form position horizontally
      transform: 'translate(-50%, -50%)', // Centers the form
      border: '1px solid black',
      padding: '20px',
      backgroundColor: '#f9f9f9',
      width: '55%', maxHeight:'94%',
      zIndex: 10 // Ensures the form is above the table
    }}>
    <h4 className='text-center my-3' style={{ color: '#1B4332', fontWeight: '600' }}>
    {language === "English" ? "Add New Bus  " : "नवीन बस जोडा"}
        </h4>
        <button
              type="button"
              onClick={() => setShowForm(false)}
              style={closeButtonStyle}
            >
              &times;
            </button>
            <form>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
  <label
    htmlFor="newBusNo"
    style={{ color: '#4a235a', fontSize: '15px' }}
  >
    {language === "English" ? "Bus No" : "बस क्रमांक"} :
  </label>
  
  <input
    type="text"
    id="newBusNo"
    value={newBusNo}
    onChange={handleInputChange}
    style={{ ...inputStyle }}
  />
  
  <button
    onClick={handleSubmit}
    style={{
      ...buttonStyle1,
      padding: '5px 20px',
      fontWeight: 'bold',
      marginLeft: '10px' // Adjust margin to keep some space between input and button
    }}
  >
    Save
  </button>
</div>

      <div style={{ overflowY: 'auto', maxHeight: '240px', marginTop:'20px', marginBottom:'20px' }}>
  <table style={tableStyle1}>
    <thead>
      <tr>
        <th style={thStyle}>{language === "English" ? "Bus No  " : "बस क्रमांक"}</th>
        <th style={thStyle}>{language === "English" ? "Action " : "कृती"}</th>
      </tr>
    </thead>
    <tbody>
  {busNumbers
    .filter((busNumber) => typeof busNumber === 'string' && busNumber.trim() !== "")
    .map((busNumber, index) => (
      <tr key={index}>
        <td style={tdStyle}>{busNumber}</td>
        <td style={tdStyle}>
          <button 
            onClick={(e) => { 
              e.preventDefault(); // Prevent default action
              handleDelete(busNumber); 
            }} 
            style={deleteButtonStyle}
          >
            <DeleteIcon />
          </button>
          <button 
            onClick={(e) => { 
              handleEditBusNo(busNumber, index, e); // Pass index as key
            }} 
            style={editButtonStyle}
          >
            <EditIcon />
          </button>
        </td>
      </tr>
    ))}
</tbody>

  </table>
</div>

    </form>
  </div>
  </div>
)}
            </div>

            <button
              type="button"
              onClick={() => setShowDriverForm(false)}
              style={closeButtonStyle}
            >
              &times;
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
const deleteButtonStyle = {
  backgroundColor: 'transparent',
  color: '#800000',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  padding: '0',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
};
const editButtonStyle = {
  backgroundColor: 'transparent',
  color: '#2F4F4F',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  padding: '0',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center', marginRight:'14px'
};

const buttonStyle1 = {
  padding: '10px 20px',
  backgroundColor: '#4a235a',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
 
};

const formRowStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '15px',
  gap:'30px',
  fontSize:'14px'
};

const labelStyle = {
  color: '#4a235a',
  fontSize: '15px',
  fontWeight: 'bold',
};
const selectStyle = {
  height: '38px',
  padding: '5px',
  marginLeft: '10px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  fontSize: '14px',
  width:'200px'
};
const inputStyle = {
  height: '35px',
  padding: '5px',
  marginLeft: '10px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  width:'200px'
};
const tableStyle1 = {
  width: '100%', 
  borderCollapse: 'collapse', 
  fontSize: '15px', 
};

const driverModalStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: '20px',
  zIndex: 1001,
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
  borderRadius: '10px',
  width: '110%',
  height: '105%',
};

const boxStyle = {
  display: 'flex',
  flexDirection: 'column',
};


const closeButtonStyle = {
  position: 'absolute',
  top: '5px',
  right: '10px',
  backgroundColor: 'red',
  color: 'black',
  border: 'none',
  fontSize: '30px',
  cursor: 'pointer',
  padding: '0px',
  margin: '0px',
  height: '40px',
  width: '40px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const tableContainerStyle = {
  maxHeight: '250px', // Adjust this height if needed to fit more rows
  overflowY: 'auto',  // Ensure vertical scrolling when content exceeds container height
  width: '100%',
  border: '2px solid #131212',
  marginTop: '2%',
  display: 'block',  // Ensure block display for table container
};

const tdStyle = {
  border: '1px solid #ddd',
  padding: '8px',
  fontSize: '14px',
 
};

const thStyle = {
  border: '1px solid #ddd', // Add border to table headers
  padding: '8px', // Reduce padding inside table headers
  textAlign: 'left',
  position: 'sticky', // Make the header sticky
  top: '0', // Stick the header to the top
  backgroundColor: '#5dade2',
  zIndex: 1, // Ensure the header is above the table content
};
export default Driver;
